import cn from 'classnames'

const responsiveClasses = (className, mode = "wide") => {
  if (typeof className === 'string') {
    return className
  } else if (className.isArray) {
    return cn(className)
  }

  const res = cn([mode == 'slim' ? className.slim : `${className.slim} ${className.wide}`, className.all])

  return res
}

export default responsiveClasses